"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAgentApiDeleteAgent = useAgentApiDeleteAgent;
// src/apis/agent-api/hooks/useDeleteAgent.ts
const recoil_1 = require("recoil");
const shared_1 = require("@heartcheck/shared");
const state_1 = require("../state");
const deleteAgentQuery = new shared_1.GraphqlQuery(
/* GraphQL */ `
    mutation DeleteAgent($id: ID!) {
      deleteAgent(id: $id) {
        id
      }
    }
  `, 
// ✅ Use Cognito User Pools (ID token) via your /graphql proxy
{ forwardAuthMode: "userpools" });
function useAgentApiDeleteAgent() {
    const setAgentsValue = (0, recoil_1.useSetRecoilState)(state_1.Agents);
    return async (id) => {
        if (!id || typeof id !== "string") {
            // eslint-disable-next-line no-console
            console.error("❌ No valid agent ID provided for deletion.");
            return;
        }
        try {
            const res = await deleteAgentQuery.invoke({ id });
            if (!res?.deleteAgent?.id) {
                throw new Error("Delete mutation did not return an ID.");
            }
            // Mark state as unloaded to trigger a clean refetch on next load.
            setAgentsValue(state_1.Loadable.unloaded());
            // eslint-disable-next-line no-console
            console.log(`✅ Agent deleted: ${res.deleteAgent.id}`);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error("❌ Failed to delete agent:", err);
            // Leave state as-is so the UI doesn't incorrectly hide items on failure.
        }
    };
}
